import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";

// #225 round 3: `?surface=day` tries the lighter of the two panel options
// (`index.css`'s `[data-surface="day"]`) while the owner picks one.
if (new URLSearchParams(location.search).get("surface") === "day") document.documentElement.dataset.surface = "day";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
